import { API_URL } from '@/const'
import { customAxios } from '@/utils'

export const getFinancialFBRequest = async () => {
  const url = `${API_URL}/profile/facebook-financial-conditions/`

  try {
    const response = await customAxios(url, 'GET', null, true)
    return response.data
  } catch (e) {
    return Promise.reject(e)
  }
}
